let baseUrl = ''
if (process.env.NODE_ENV === 'development') {
  baseUrl = '/xkh/teacherapi'
} else {
  baseUrl = '//xkhteacher.aixuexi.com/xkh/teacherapi'
}

export default {
  // 课程权益---按机构权益类型查询 https://yapi.aixuexi.com/project/42/interface/api/196985
  getInsQuota: `${baseUrl}/cardequity/ins/quota`
}
